
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/translate-video/japanese-to-english",
      function () {
        return require("private-next-pages/translate-video/japanese-to-english.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/translate-video/japanese-to-english"])
      });
    }
  